import React, {useCallback, useState} from 'react';
import {Button, Container, Col, Row} from 'reactstrap';
import {Link, animateScroll as scroll} from 'react-scroll';
import classNames from 'classnames';
import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent';

export default function ModalExitSales({version = 'full', ...props}) {
  const {isOpen, toggle} = useExitIntent(60000);

  return (
    <Modal className="modal-exit-intent modal-exit-intent-empowerment" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          {version === 'sales297' ? (
            <>
              <h4 className="section-heading">
                Don't miss out! <br className="d-none d-lg-block d-xl-none" />
                You'll only get <br className="d-none d-sm-block d-lg-none" />
                this special offer here.
              </h4>
              <p>
                Get <em>Healthy Brain,</em> the <br className="d-none d-lg-block d-xl-none" />
                life-changing course, <br className="d-none d-sm-block d-xl-none" />
                for only $297 — <strong>a $200 savings.</strong>
              </p>
            </>
          ) : (
            <>
              <h4 className="section-heading">
                Your brain cares about <br className="d-none d-sm-block" />
                your next move.
              </h4>
              <h5 className="mt-0">
                The incredible potential of your <br className="d-none d-sm-block d-lg-none d-xl-block" />
                brain lies in your hands.
              </h5>
              <p>
                Invest in your brain health and own <em>Healthy Brain,</em>{' '}
                <br className="d-none d-sm-block d-lg-none" />
                the life-changing course, for just $497.
              </p>
            </>
          )}
          <Button
            className="btn-exit text-uppercase text-white text-h5"
            color="cta"
            onClick={toggle}
            block
            activeClass="active"
            spy={true}
            offset={-55}
            to="hbc-join-cta-1"
            smooth={true}
            href="#"
            tag={Link}
          >
            {version === 'sales297' ? (
              <>
                Save money AND invest <br className="d-none d-sm-block d-lg-none d-xl-block" />
                in your brain TODAY
              </>
            ) : (
              'Get it Now'
            )}
          </Button>
        </Col>
        <Col xs="12" lg="5" className="exit-modal-image-col order-lg-1">
          <div
            className={classNames(
              `exit-modal-image background-image-${version === 'sales297' ? 'man-tablet' : 'couple-couch'}`
            )}
          />
        </Col>
      </Row>
    </Modal>
  );
}
